enum ErrorTypes {
    ServiceUnavailable = 'Service unavailable',
    OrganizationNotFound = 'Organization not found',
    UnauthorizedUser = 'Request failed with status code 403',
    itemModifiedOutOfContext = 'Error: Request failed with status code 412'
}

export default ErrorTypes;